import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = () => ({
    templates: [],
    template: {
        id: null,
        name: '',
        description: '',
        schema: {},
        customer_id: null,
        isActive: true,
        createdAt: null,
        updatedAt: null,
    },
    createTemplateLoading: false,
    updateTemplateLoading: false,
    deleteTemplateLoading: false,
    fetchTemplateLoading: false,
    fetchTemplatesLoading: false,
});

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};